//配置全局访问的接口地址
//export const API_URL = 'http://localhost:8024/';// 接口地址
export const API_URL = 'http://api.defaultcode.cn';// 接口地址
//export const FileStorage_URL = 'http://localhost:8025'; // 文件存储地址
export const FileStorage_URL = 'http://image-static.defaultcode.cn'; // 文件存储地址
export const WebSite_Name = '默认代码技术社区'; // 网站名称